'use es6';
/*
 * Specific to USER attributes.
 * Value will be hyphen-cased to API and localStorage slugs.
 *
 * https://git.hubteam.com/HubSpot/DesignManagerApi/pull/1035
 */

export const DESIGN_MANAGER_USER_SETTINGS = 'DESIGN_MANAGER_USER_SETTINGS';